import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairCancelRegistrationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairCancelRegistrationModalContainer" */
      './StaffGradFairCancelRegistrationModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
